var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.User.isLogged && +_vm.User.id === +_vm.userId)?_c('v-list-item',{on:{"click":function($event){return _vm.postDialogDelete(_vm.id)}}},[_c('v-list-item-title',[_c('v-icon',[_vm._v("mdi-delete-outline")]),_vm._v(" Удалить ")],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }